import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { ISelectOption } from 'src/app/interfaces/select.interfaces';
@Component({
    selector: 'chip',
    templateUrl: 'chip.component.html',
    styleUrls: ['chip.component.scss'],
    standalone: false
})
export class ChipComponent implements OnInit {
    @Input() public value: string | number = '';
    @Input() public text?: string;
    @Input('text-align') public textAlign: 'start' | 'center' | 'end' = 'center';
    @Input() public disabled = false;
    @Input() public selected = false;
    @Input() public stratch = false;
    @Input() public hint?: string;

    @Output() public onSelectionChange = new EventEmitter<ISelectOption>();

    public constructor() {}

    public ngOnInit() {}

    public onSelectionHendler(e: MouseEvent) {
        // console.log('chip', this.value, this.selected, this.text);
        if (!this.disabled) {
            this.onSelectionChange.emit({
                value: this.value,
                text: this.text,
                selected: !this.selected,
            });
        }
    }
}
